import {
  NEWDANHMUCCHIPHIPHATSINH_COUNT_ASSIGN_SUCCESS,
  NEWDANHMUCCHIPHIPHATSINH_HISTORY_LIST_SUCCESS,
  NEWDANHMUCCHIPHIPHATSINH_IMPORT_SUCCESS,
  NEWDANHMUCCHIPHIPHATSINH_LIST_SUCCESS,
  NEWDANHMUCCHIPHIPHATSINH_NEW_CARE_SUCCESS,
  NEWDANHMUCCHIPHIPHATSINH_ONE_SUCCESS,
  NEWDANHMUCCHIPHIPHATSINH_UPDATE_FILTER,
  NEWDANHMUCCHIPHIPHATSINH_SAVE_SUCCESS,
  NEWDANHMUCCHIPHIPHATSINH_UPDATE_HOMEPAGE_FILTER,
  NEWDANHMUCCHIPHIPHATSINH_HOMEPAGE_LIST_SUCCESS,
  NEWDANHMUCCHIPHIPHATSINH_HOMEPAGE_ONE_SUCCESS,
  NEWDANHMUCCHIPHIPHATSINH_HANDLE_IMPORT_ERRORS,
} from 'src/actions/newdanhmucchiphiphatsinh.action';
import { LOOKUP_CLEANER } from 'src/actions/lookup.action';

import {
  DEFAULT_ROW_PER_PAGE,
} from 'src/utils/constants';

const initState = {
  filter: {
    so_dien_thoai: '',
    loai_sim: {},
    page: 0,
    limit: DEFAULT_ROW_PER_PAGE,
  },
  homepageNewdanhmucchiphiphatsinhFilter: {
    so_dien_thoai: '',
    loai_sim: {},
    homepageNewdanhmucchiphiphatsinhPage: 0,
    homepageNewdanhmucchiphiphatsinhLimit: DEFAULT_ROW_PER_PAGE,
  },
  items: [],
  total: 0,
  selected: undefined,
  homepageNewdanhmucchiphiphatsinhItems: [],
  homepageNewdanhmucchiphiphatsinhTotal: 0,
  homepageNewdanhmucchiphiphatsinhSelected: undefined,
  temp: [],
  countAssign: 0,
  history: [],
  totalHistory: 0,
  newCare: undefined,
  canCare: 0,
  temp_upgoicuoc: [],
  errorRows: {},
}

const newdanhmucchiphiphatsinhReducer = (state = initState, action) => {
  switch (action.type) {
    case NEWDANHMUCCHIPHIPHATSINH_UPDATE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.filter !== 'undefined' && state.filter) {
        if (action.data.page == 'no_update' && typeof state.filter.page !== 'undefined') action.data.page = state.filter.page;
        if (action.data.limit == 'no_update' && typeof state.filter.limit !== 'undefined') action.data.limit = state.filter.limit;
      }
      return {
        ...state,
        filter: action.data,
      }
    }
    case NEWDANHMUCCHIPHIPHATSINH_LIST_SUCCESS: {
      return {
        ...state,
        items: action.data.items,
        total: action.data.total,
      }
    }
    case NEWDANHMUCCHIPHIPHATSINH_ONE_SUCCESS: {
      return {
        ...state,
        selected: action.data
      }
    }
    case NEWDANHMUCCHIPHIPHATSINH_UPDATE_HOMEPAGE_FILTER:  {
      if (action.data && typeof action.data !== 'undefined' && action.data && typeof state.homepageNewdanhmucchiphiphatsinhFilter !== 'undefined' && state.homepageNewdanhmucchiphiphatsinhFilter) {
        if (action.data.homepageNewdanhmucchiphiphatsinhPage == 'no_update' && typeof state.homepageNewdanhmucchiphiphatsinhFilter.homepageNewdanhmucchiphiphatsinhPage !== 'undefined') action.data.homepageNewdanhmucchiphiphatsinhPage = state.homepageNewdanhmucchiphiphatsinhFilter.homepageNewdanhmucchiphiphatsinhPage;
        if (action.data.homepageNewdanhmucchiphiphatsinhLimit == 'no_update' && typeof state.homepageNewdanhmucchiphiphatsinhFilter.homepageNewdanhmucchiphiphatsinhLimit !== 'undefined') action.data.homepageNewdanhmucchiphiphatsinhLimit = state.homepageNewdanhmucchiphiphatsinhFilter.homepageNewdanhmucchiphiphatsinhLimit;
      }
      return {
        ...state,
        homepageNewdanhmucchiphiphatsinhFilter: action.data,
      }
    }
    case NEWDANHMUCCHIPHIPHATSINH_HOMEPAGE_LIST_SUCCESS: {
      return {
        ...state,
        homepageNewdanhmucchiphiphatsinhItems: action.data.homepageNewdanhmucchiphiphatsinhItems,
        homepageNewdanhmucchiphiphatsinhTotal: action.data.homepageNewdanhmucchiphiphatsinhTotal,
      }
    }
    case NEWDANHMUCCHIPHIPHATSINH_HOMEPAGE_ONE_SUCCESS: {
      return {
        ...state,
        homepageNewdanhmucchiphiphatsinhSelected: action.data
      }
    }
    case NEWDANHMUCCHIPHIPHATSINH_NEW_CARE_SUCCESS: {
      return {
        ...state,
        newCare: action.data.newCare,
        canCare: action.data.canCare,
      }
    }
    case NEWDANHMUCCHIPHIPHATSINH_IMPORT_SUCCESS: {
      return {
        ...state,
        temp: action.data,
      }
    }
    case NEWDANHMUCCHIPHIPHATSINH_COUNT_ASSIGN_SUCCESS: {
      return {
        ...state,
        countAssign: action.data,
      }
    }
    case NEWDANHMUCCHIPHIPHATSINH_HISTORY_LIST_SUCCESS: {
      return {
        ...state,
        history: action.data.items,
        totalHistory: action.data.total,
      }
    }
    case LOOKUP_CLEANER: {
      return initState
    }
    case NEWDANHMUCCHIPHIPHATSINH_SAVE_SUCCESS: {
      return {
        ...state,
        temp_upgoicuoc: []
      }
    }
    case NEWDANHMUCCHIPHIPHATSINH_HANDLE_IMPORT_ERRORS: {
      return {
        ...state,
        errorRows: action.data,
      }
    }
    default: {
      return state;
    }
  }
}
export default newdanhmucchiphiphatsinhReducer